import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    template: '<router-outlet></router-outlet>',
})
export class AuthenticationLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/common/authentication-layout.component.ts